<template>
  <div>
    <draggable v-model="list" group="menu" @start="onDragStart">
      <div v-for="item in list" :key="item.id + item.url">
        <el-submenu class="menu" :disabled="item.disabled" :index="item.serial"
          v-if="item.children && item.children.length">
          <template slot="title" style="padding-left: 10px;">
            <i :class="item.icon"></i>
            <span slot="title" style="font-size: 16px">{{ item.name }}</span>
          </template>
          <MenuTree :menuList="item.children" style="background: #228ef1;"></MenuTree>
        </el-submenu>
        <el-menu-item v-else :disabled="item.disabled" :index="item.serial" @click="savePath(item)">
          <i :class="item.icon"></i>
          <!-- :title="item.name" -->
          <span :style="{ 'font-size': item.url ? '12px' : '16px' }">{{ getShowVal(item) }} </span>
        </el-menu-item>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: "MenuTree", //模板名称
  components: { draggable },
  data() {
    return {
      list: [],
    };
  },
  beforeMount() { },
  props: ["menuList"],
  watch: {
    menuList: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.list = newVal;
        }
      },
    },
  },
  methods: {
    getShowVal(item) {

      const { name, id, classId = '', subClassId = '', description = '' } = item
      if (classId && subClassId && description) {
        return name + '-' + description
      }
      return name
    },
    //保存激活路径
    savePath(data) {
      // console.log(data,data.hasOwnProperty('link'));
      if (!data.url && !data.hasOwnProperty('link')) {
        return;
      }
      this.$store.commit('menuClick', data)

      // if (data.id == 10405) {
      //   this.$emit('menuclick', data);
      //   this.$parent.$parent.$emit('menuclick', data);

      // }

      // // this.$store.commit("setQuickCreate", {});
      // if (data.url || data.parentId == 'setting') {
      //   // this.$emit('menuclick', data);
      //   // this.$parent.$parent.$emit('menuclick', data);
      //   // this.$parent.$parent.$parent.$parent.$emit('menuclick', data);
      // }
    },
    onDragStart(event) {
      const menu = event.item['_underlying_vm_'];
      this.$store.commit('SET_DRAG_MENU', menu)
    },
  },

};
</script>

<style>
.el-menu--collapse {
  width: auto;
}

.el-menu--collapse span,
.el-menu--collapse i.el-submenu__icon-arrow {
  height: 0;
  width: 0;
  overflow: hidden;
  visibility: hidden;
  display: inline-block;
}

.el-menu-item,
.el-submenu__title {
  height: 46px;
  line-height: 46px;
  position: relative;
  /* -webkit-box-sizing: border-box; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  list-style: none;
  min-width: 20px;
}
</style>
<style scoped>
::v-deep .el-menu.el-menu--popup.el-menu--popup-right-start {
  max-width: 600px;
  max-height: 650px;
  overflow: auto;
}
</style>



<!-- <template>
  <div>
    <template v-for="item in this.menuList">
        <el-submenu :disabled="item.disabled" :index="item.id+''" v-if="item.children.length>0" :key="item.id">
          <template slot="title" style="padding-left:10px;">
            <i :class="item.icon"></i>
            <span slot="title" style="font-size: 16px;">{{ item.name}}</span>
          </template>
          <MenuTree :menuList="item.children"  style="background: #228ef1;"></MenuTree>
        </el-submenu>
        <el-menu-item v-else :disabled="item.disabled" :index="item.url+''" :route="item.url" :key="item.index"
          @click="savePath(item.url,item.name,item.type, item.id)">
          <i :class="item.icon"></i>
          <span style="font-size: 16px;" :title="item.name">{{item.name}}</span>
        </el-menu-item>
    </template>
  </div>
</template>
<style>
  .el-menu--collapse span,
  .el-menu--collapse i.el-submenu__icon-arrow {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
  }

</style>
<script>
  export default {
    name: "MenuTree", //模板名称
    data() {
      return {
        name_: "",
      };
    },
    beforeMount() {},
    props: ["menuList", "tagList", ],
    methods: {
      //保存激活路径
      savePath(path, name, type, id) {
        //var asas = this.$store.state;
        //console.log(path,name);
        //this.$store.commit("setListName", name);
        //var name = this.$store.state.listName;
        //console.log(name);
        this.$store.commit("setQuickCreate", {});
        this.$parent.$parent.$emit('meunclick', {
          "name": name,
          "path": path,
          "type": type,
          "id": id
        });
        this.$parent.$parent.$parent.$parent.$emit('meunclicktwo', {
          "name": name,
          "path": path,
          "type": type,
          "id": id
        });
      },
    },
    created() {

    }
  };
</script> -->